import api from '@services/api';
import {
  CostTrackingRequest,
  CostTrackingResponse,
  CostTrackingUpdate,
  IntervalReference,
  IntervalRequest,
} from '../models/costTracking';
import { CostTrackingTotalUpdate, TotalityResponse } from '../models/costTrackingTotal';

/**
 * <p>
 * API endpoints that cover all cost tracking CRUD calls
 */
export const costTrackingApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchCostTracking: builder.query<CostTrackingResponse[], CostTrackingRequest>({
      query: (parans: CostTrackingRequest) => ({
        url: encodeURI(`/report/cost-tracking/search?project=${parans.project}&rubric=${parans.rubric}`),
      }),
      providesTags: ['SearchCostTracking', 'SearchDetails'],
    }),
    updateCostTracking: builder.mutation<void, CostTrackingUpdate>({
      query: (project) => ({
        url: encodeURI(`/report/cost-tracking/update`),
        method: 'PUT',
        body: project,
      }),
      invalidatesTags: ['SearchCostTracking'],
    }),
    searchIntervalReference: builder.query<IntervalReference, IntervalRequest>({
      query: (parans: IntervalRequest) => ({
        url: encodeURI(`/report/cost-tracking/interval-reference?project=${parans.project}`),
      }),
      providesTags: ['SearchCostTracking', 'SearchDetails'],
    }),
    searchTotality: builder.query<TotalityResponse, CostTrackingRequest>({
      query: (parans: CostTrackingRequest) => ({
        url: encodeURI(`/report/cost-tracking-total/totality?project=${parans.project}&rubric=${parans.rubric}`),
      }),
      providesTags: ['SearchCostTracking', 'SearchDetails', 'SearchTotality'],
    }),
    updateTotality: builder.mutation<void, CostTrackingTotalUpdate>({
      query: (project) => ({
        url: encodeURI(`/report/cost-tracking-total/update`),
        method: 'PUT',
        body: project,
      }),
      invalidatesTags: ['SearchCostTracking', 'SearchTotality'],
    }),
  }),
});

export const {
  useSearchCostTrackingQuery,
  useUpdateCostTrackingMutation,
  useSearchTotalityQuery,
  useSearchIntervalReferenceQuery,
  useUpdateTotalityMutation,
} = costTrackingApi;
